
import { useState, useRef, forwardRef, useImperativeHandle } from "react";
import { CiFileOn } from "react-icons/ci";

const FileInput = forwardRef(({ callback, accept, defaultText, value = [] }, ref) => {
    const [fileName, setFileName] = useState("");
    const fileInputRef = useRef(null);

    useImperativeHandle(ref, () => ({
        reset: () => {
            setFileName("");
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
        }
    }));

    return (
        <div className="relative flex items-center border border-gray-300 rounded-lg p-3 cursor-pointer hover:border-brand-500 transition">
            {/* Display selected file name or default text */}
            <span className="flex-1 text-sm text-gray-700 truncate">
                {value?.name ?? defaultText}
            </span>


            {/* Hidden actual input */}
            {/* {value.length > 0 ? value.map(file => file.name).join(", ") : defaultText} */}
            <input
                type="file"
                accept={accept}
                className="absolute inset-0 opacity-0 cursor-pointer"
                onChange={(e) => {
                    const file = e.target.files[0]; // only one file
                    callback(file || null);
                }}
                ref={fileInputRef}
            />

            {/* File Icon */}
            <CiFileOn className="text-gray-500 text-xl ml-2 shrink-0" />
        </div>
    );
});

export default FileInput;